import { Button } from "../../components/ui/button";
import { ArrowLeft } from "lucide-react";
import { FormattedMessage, useIntl } from "react-intl";
function AppointmentHeader({ onNavigate }) {
  return (
    <div className="flex items-center">
      <Button
        variant="ghost"
        onClick={() => onNavigate("dashboard")}
        className="p-2"
      >
        <ArrowLeft className="h-5 w-5" />
      </Button>
      <h1 className="text-lg font-semibold">
        <FormattedMessage id="Appointment.Details" />
      </h1>
    </div>
  );
}
export default AppointmentHeader;
